import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../service/auth.service';
import { EcomicService } from '../service/comics/ecomic.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.css']
})
export class SendEmailComponent implements OnInit {
  EmailForm: FormGroup;
  loading: boolean = false;
  load: boolean = false;
  thumbnail_image: File;
  cover_image: File;
  cover_image_url: any;
  coverimageerror: any = false;
  AllUsers=[];
  emails: any=[];
  SelectedUser:any="All";
  users=['All','Individual'];
  SentUsers:any=0;
  userdetails: any;
  bodyData: string;
  cover: any;
  isSendEmail: boolean=false;
  HTMLBody: string;
  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,private http:HttpClient) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.EmailForm = this.form.group({
      subject: ['Webnnel Alerts', [Validators.required]],
      body: ['', [Validators.required]],
      selected:['All',[]],
      to: ['', []],
      from: ['webnnel.alerts@gmail.com', [Validators.required]],
    });
    this.auth.getuser().then(userdetails => {
      this.userdetails = userdetails ? userdetails : JSON.parse(localStorage.getItem('user'));
      console.log
    });
   this.getAllUsers()
  }
    getAllUsers(){
      this.afs.collection("users").valueChanges().subscribe((users)=>{
        this.AllUsers = users;
        this.emails = [];
        this.AllUsers.forEach(element => {
          if(element.email){
            this.emails.push(element.email);
          }
        });
      })
    }
    selected(value){
      this.SelectedUser=value;
    }
    async addchapter(value, valid) {
      this.isSendEmail = true;
          if (valid) {
            this.loading = true;
              try {
                  if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
                  const coverimage = await this.auth.uploadimage('wis/cover/', this.cover_image, false);
                  this.cover  = coverimage['Location'];
                  var url = "https://hisingsvandring.se/email/email.php";

                  this.bodyData = `<img src="${this.cover}"  style="height:auto;width: 100%; border-radius: 8px;"><br>${value.body}<br><h5 style="color:gray;text-align:center;">Powered By </h5> <div style="text-align:center;"><a href="https://webnnel.com/"><img src="https://webnnel.nyc3.digitaloceanspaces.com/WIS/Sponsor_App/200x200.png"  style="height:50px; width: 50px;"></a></div>`;
                  this.HTMLBody = `<!DOCTYPE html>
                  <html lang="en">
                  <head>
                      <meta charset="UTF-8">
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Webnnel</title>
                  </head>
                  <body>
                  ${this.bodyData}
                  </body>
                  </html>`;
                  var EmailLength = this.emails.length;
                  this.SentUsers = 0;
                  if(this.SelectedUser === "All"){
                      const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
                      (async () => {
                      for (let i = 0; i < EmailLength; i++) {
                        var formData = new FormData();
                      formData.append("to", this.emails[i]);
                      formData.append("from",value.from);
                      formData.append("subject",value.subject);
                      formData.append("body",this.HTMLBody);
                      this.postData(formData,url).subscribe((respone:any)=>{
                        this.SentUsers++;
                        if(EmailLength - 1 === i){
                          this.loading = false;
                          this.load = false;
                          this.toastr.success('Email sent successfully to all users!', 'Success!');
                          this.saveEmail();
                        }
                      },error=>{
                        console.log(error)
                      }
                      );
                      await sleep(250);
                      }
                      console.log("done");
                      })();
                  }
                  else if(this.SelectedUser === "Individual"){
                    let formData = new FormData();
                    formData.append("to", value.to);
                    formData.append("from",value.from);
                    formData.append("subject",value.subject);
                    formData.append("body",this.HTMLBody);
                    this.postData(formData,url).subscribe((respone:any)=>{
                        this.loading = false;
                        this.load = false;
                        this.toastr.success('Email sent successfully!', 'Success!');
                        this.saveEmail();
                    });
                  }
              
              } catch (error) {
                this.loading = false;
                this.load = true;
              }
          } else {
            console.log('error');
          }
        }
  changeListner2(event) {
    this.coverimageerror = false;
    if (event.target.files && event.target.files[0]) {
      this.cover_image = event.target.files[0];
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.cover_image_url = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
    
  }
  postData(formData,Url){
    return this.http.post(Url,formData)
  }
  ngOnDestroy(){
    
   
  }
  async saveEmail(){
    let data ={
      from:this.EmailForm.value.from,
      subject:this.EmailForm.value.subject,
      type:this.EmailForm.value.selected,
      to:this.EmailForm.value.to,
      sentUsers:this.EmailForm.value.selected === "All" ? this.SentUsers : "",
      totalUsers:this.EmailForm.value.selected === "All" ? this.emails.length : "",
      bodyData:this.HTMLBody,
      body:this.EmailForm.value.body,
      cover_image:this.cover,
      sentBy:this.userdetails,
      createdAt : new Date(),
      date : new Date().toString(),
    }
    const emailSend = await this.afs.collection('SentEmails').add(data);
    const esid = emailSend.id;
    const id = await this.afs.doc(`/SentEmails/${esid}`).update({ id: esid });
    setTimeout(() => {
      this.router.navigate(["/email-history"])
    }, 3000);
  }
}



// WEBPACK FOOTER //
// ./src/app/send-email/send-email.component.ts